import React from 'react';
import FirebaseConnectionTest from '../components/FirebaseConnectionTest';

const FirebaseTestPage: React.FC = () => {
  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(90deg, #FF00F5 0%, #FFFFFF 100%)',
      padding: '20px'
    }}>
      <div style={{ textAlign: 'center', marginBottom: '30px' }}>
        <h1 style={{ 
          color: '#333', 
          fontSize: '2.5rem',
          marginTop: '40px',
          marginBottom: '10px'
        }}>
          Wiin 2.0 - Phase 1 Testing
        </h1>
        <p style={{ color: '#666', fontSize: '1.1rem' }}>
          Firebase Configuration & Integration Test
        </p>
      </div>
      
      <FirebaseConnectionTest />
      
      <div style={{
        maxWidth: '600px',
        margin: '30px auto',
        padding: '20px',
        backgroundColor: 'white',
        borderRadius: '12px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
      }}>
        <h3 style={{ marginBottom: '15px', color: '#333' }}>
          📋 Phase 1 Checklist
        </h3>
        <ul style={{ lineHeight: '1.8', color: '#666' }}>
          <li>✅ Firebase configuration verified</li>
          <li>✅ TypeScript interfaces created (Campaign, Prize, GameResult)</li>
          <li>✅ Campaign service implemented</li>
          <li>✅ Firestore security rules configured</li>
          <li>⏳ Seed campaigns (use button above)</li>
          <li>⏳ Test complete integration</li>
        </ul>
        
        <div style={{
          marginTop: '20px',
          padding: '15px',
          backgroundColor: '#f0f0f0',
          borderRadius: '8px'
        }}>
          <strong>Next Steps:</strong>
          <ol style={{ marginTop: '10px', lineHeight: '1.8' }}>
            <li>Deploy Firestore rules: <code>firebase deploy --only firestore:rules</code></li>
            <li>Seed campaign data using the button above</li>
            <li>Verify campaigns appear in Firebase Console</li>
            <li>Proceed to Phase 2: Modify Existing Pages</li>
          </ol>
        </div>
      </div>
    </div>
  );
};

export default FirebaseTestPage;

